import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { requestAuth } from '../../http/httpRequest'
import { toastOn } from '../../store/slices/toast'
import { TitleSection } from './formularioDeCompra/aditionalComponents'
export const AlmacenTraspasosForm = ({
    field,
    values,
    setValues,
}) => {
    const dispatch = useDispatch()
    const [list, setList] = useState([])
    const [listRolnames, setListRolnames] = useState([])
    const [data, setData] = useState([])
    const [cantidadEgreso, setCantidadEgreso] = useState(0)
    const [cantidadRestante, setCantidadRestante] = useState(field.generalData?.cantidad || 0)

    const getData = async () => {
        await requestAuth(
            'get',
            field?.urlApi,
            null,
            field?.params ?? {}
        )
            .then((response) => {
                setList(response.data)
                setData(response.data.map(s => ({ 'almProductoId': s.id + '', 'cantidad': 0, 'observacion': '' })))
                setListRolnames([...new Set(response.data?.map(s => s.rolname) ?? [])]);
            }
            )
            .catch(error => {
                dispatch(toastOn({ type: 'danger', message: error?.response?.data?.message || 'error a listar las casillas.' }))
            })
    }

    useEffect(() => {
        getData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const addData = (value, name) => {
        const newData = data.map(item => {
            if (item.almProductoId === name) {
                const cantidad = parseFloat(value) || 0;
                if (field.capacidadProd) {
                    const cantidad2 = field.capacidadProd === '200LT' ? cantidad * 2 : cantidad / 2;
                    return { ...item, cantidad, cantidad2 };
                }
                return { ...item, cantidad };
            }
            if (item.almProductoId + 'Destino' === name) {
                return { ...item, cantidad2: parseFloat(value) };
            }
            if (item.almProductoId + 'Obs' === name) {
                return { ...item, observacion: value };
            }
            return item;
        })
        setData(newData)
        const totalCantidad = newData.reduce((total, item) => total + parseFloat(item.cantidad || 0), 0);
        setCantidadEgreso(totalCantidad)
        if (field.isIngress) {
            setCantidadRestante(parseFloat(field.generalData?.cantidad) + totalCantidad)
        }
        else {
            setCantidadRestante(parseFloat(field.generalData?.cantidad) - totalCantidad)
        }
        setValues('dataList', newData)
    }
    return (
        <div className='col-start-1 col-end-13 dark:text-gray-100 bg-gray-100 dark:bg-gray-700 border border-gray-200 dark:border-gray-500 rounded p-3' >
            <center className='font-semibold mb-2'>{field.title}</center>
            <div className='flex flex-row gap-2 mb-2 text-sm bg-gray-200 dark:bg-gray-800 p-2 rounded font-bold dark:text-gray-300 text-gray-700 justify-center'>
                <div>
                    <span>Producto:</span> <span className='dark:text-blue-400 text-blue-600'>{field.generalData?.nombreProd}, {field.generalData?.tipoProd}</span>
                </div>
                <div>
                    <span>Cantidad actual:</span> <span className='dark:text-blue-400 text-blue-600'>{field.generalData?.cantidad}</span>
                </div>
                <div>
                    <span>Cantidad {field.isIngress ? 'ingreso' : 'egreso'}:</span> <span className='dark:text-blue-400 text-blue-600'>{cantidadEgreso}</span>
                </div>
                <div>
                    <span>Cantidad restante:</span> <span className='text-teal-600 dark:text-teal-500'>{cantidadRestante}</span> {cantidadRestante < 0 && <span className='text-red-500'>error al distribuir!</span>}
                </div>
            </div>
            {
                listRolnames && listRolnames.length > 0 ?
                    listRolnames.map((rolname, idx) => (
                        <div
                            key={idx}
                            className='mb-2'
                        >
                            <div className='text-center'><TitleSection title={rolname} /></div>
                            <SectionCards
                                list={list.filter(l => l.rolname === rolname)}
                                field={field}
                                addData={addData}
                                dataItems={data}
                            />
                        </div>
                    ))
                    :
                    <SectionCards
                        list={list}
                        field={field}
                        addData={addData}
                        dataItems={data}
                    />
            }
            {/* <div
                className='grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-2 max-h-80 overflow-auto'
            >
                {
                    list?.map((i, index) => (
                        <div
                            key={index}
                            className='dark:bg-gray-800 bg-stone-300 p-2 rounded-lg'
                        >
                            <div
                                className='flex mb-2 gap-1 overflow-hidden text-sm'
                            >
                                <label
                                    htmlFor={index}
                                    className='dark:text-gray-400 text-gray-700 font-semibold text-nowrap overflow-hidden'
                                >
                                    {i[field.indexLabel]}
                                </label>
                                <div
                                    className='dark:text-teal-400 text-teal-700 font-bold ml-auto'
                                >
                                    {i.cantidad}
                                </div>
                            </div>
                            <div className='flex gap-1'>
                                <input
                                    id={index}
                                    type='number'
                                    name={i.id + ''}
                                    className={`shadow-sm outline-none [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 font-semibold disabled:opacity-55 disabled:text-gray-500 dark:disabled:text-gray-400 ${field.highlight}`}
                                    defaultValue={0}
                                    onChange={(e) => addData(e.target.value, e.target.name)}
                                />
                                {
                                    field.isDoubleAmount &&
                                    <input
                                        id={index}
                                        type='number'
                                        name={i.id + 'Destino'}
                                        className={`shadow-sm outline-none [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 font-semibold disabled:opacity-55 disabled:text-gray-500 dark:disabled:text-gray-400 ${field.highlight}`}
                                        defaultValue={0}
                                        onChange={(e) => addData(e.target.value, e.target.name)}
                                    />
                                }
                            </div>
                        </div>
                    ))
                }
            </div> */}
        </div >
    )
}

const SectionCards = ({ list, field, addData, dataItems }) => {
    const inputBase = `shadow-md outline-none [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none border text-gray-900 text-sm rounded-lg block w-full p-2.5 dark:placeholder-gray-400 dark:text-white font-semibold ${field.highlight}`
    const inputEditable = `${inputBase} border-gray-300 focus:ring-blue-600 focus:border-blue-600 dark:border-gray-500 dark:focus:ring-blue-500 dark:focus:border-blue-500`
    const inputReadonly = `${inputBase} border-gray-200 bg-gray-100 cursor-not-allowed dark:border-gray-600 dark:bg-gray-600 dark:text-gray-300`

    const labelOrigen = field.capacidadProd === '200LT' ? '200LT' : field.capacidadProd === '100LT' ? '100LT' : null
    const labelDestino = field.capacidadProd === '200LT' ? '→ 100LT' : field.capacidadProd === '100LT' ? '→ 200LT' : null

    const filteredList = field.excludeTCC
        ? (list ?? []).filter(i => i[field.indexLabel] !== 'TCC')
        : (list ?? [])

    return (
        <div
            className='grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-2 max-h-80 overflow-auto'
        >
            {
                filteredList.map((i, index) => {
                    const dataItem = dataItems?.find(d => d.almProductoId === i.id + '')
                    return (
                        <div
                            key={index}
                            className='dark:bg-gray-800 bg-gray-300/70 p-2 rounded-lg'
                        >
                            <div
                                className='flex mb-2 gap-1 overflow-hidden text-sm'
                            >
                                <label
                                    htmlFor={index}
                                    className='dark:text-gray-400 text-gray-700 font-semibold text-nowrap overflow-hidden'
                                >
                                    {i[field.indexLabel]}
                                </label>
                                <div
                                    className='dark:text-teal-400 text-teal-700 font-bold ml-auto'
                                >
                                    {i.cantidad}
                                </div>
                            </div>
                            <div className='flex gap-1'>
                                <div className='flex flex-col w-full'>
                                    {labelOrigen && <span className='text-xs text-gray-500 dark:text-gray-400 mb-0.5'>{labelOrigen}</span>}
                                    <input
                                        id={index}
                                        type='number'
                                        name={i.id + ''}
                                        className={inputEditable}
                                        defaultValue={0}
                                        onChange={(e) => addData(e.target.value, e.target.name)}
                                    />
                                </div>
                                {
                                    field.isDoubleAmount && (
                                        field.capacidadProd ? (
                                            <div className='flex flex-col w-full'>
                                                <span className='text-xs text-blue-500 dark:text-blue-400 mb-0.5 font-semibold'>{labelDestino}</span>
                                                <input
                                                    type='number'
                                                    readOnly
                                                    value={dataItem?.cantidad2 ?? 0}
                                                    className={inputReadonly}
                                                    onChange={() => {}}
                                                />
                                            </div>
                                        ) : (
                                            <input
                                                id={index}
                                                type='number'
                                                name={i.id + 'Destino'}
                                                className={inputEditable}
                                                defaultValue={0}
                                                onChange={(e) => addData(e.target.value, e.target.name)}
                                            />
                                        )
                                    )
                                }
                            </div>
                            <input
                                type='text'
                                name={i.id + 'Obs'}
                                placeholder='Observación...'
                                className='mt-1 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-1.5 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:bg-gray-700'
                                onChange={(e) => addData(e.target.value, e.target.name)}
                            />
                        </div>
                    )
                })
            }
        </div>
    )
}